import React from 'react';
import { motion } from 'framer-motion';
export function MusicalNotesBackground() {
  // Musical note symbols
  const notes = ['♪', '♫', '♬', '♩', '♭', '♮', '♯'];
  // Generate random positions for notes
  const generateNotes = () => {
    const noteElements = [];
    const noteCount = 30; // Number of notes to display
    for (let i = 0; i < noteCount; i++) {
      const randomNote = notes[Math.floor(Math.random() * notes.length)];
      const randomX = Math.random() * 100; // Random X position (0-100%)
      const randomY = Math.random() * 100; // Random Y position (0-100%)
      const randomSize = 20 + Math.random() * 40; // Random size (20-60px)
      const randomOpacity = 0.02 + Math.random() * 0.06; // Very subtle opacity (0.02-0.08)
      const randomRotation = Math.random() * 360; // Random rotation
      const randomDelay = Math.random() * 10; // Random animation delay
      noteElements.push({
        id: i,
        symbol: randomNote,
        x: randomX,
        y: randomY,
        size: randomSize,
        opacity: randomOpacity,
        rotation: randomRotation,
        delay: randomDelay
      });
    }
    return noteElements;
  };
  const musicalNotes = generateNotes();
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-240">
      {/* Gradient overlay for extra subtlety */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cream/30 to-transparent" data-id="element-241" />

      {/* Musical notes */}
      {musicalNotes.map(note => <motion.div key={note.id} className="absolute text-navy font-serif" style={{
      left: `${note.x}%`,
      top: `${note.y}%`,
      fontSize: `${note.size}px`,
      opacity: note.opacity,
      transform: `rotate(${note.rotation}deg)`
    }} initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: [note.opacity * 0.5, note.opacity, note.opacity * 0.5],
      scale: [0.95, 1, 0.95],
      rotate: [note.rotation, note.rotation + 10, note.rotation]
    }} transition={{
      duration: 15 + Math.random() * 10,
      repeat: Infinity,
      delay: note.delay,
      ease: 'easeInOut'
    }} data-id="element-242">
          {note.symbol}
        </motion.div>)}
    </div>;
}